import { apiRequest } from "../../utils/apiUtils";

export const BoardApi = {
  uploadArticleImage: (formData: FormData) =>
    apiRequest<any>("post", "/board/upload", {
      data: formData,
      fullResponse: true,
    }),
};
